<template>
  <div>
    <h3 style="margin: 0; padding: 0">Tumor {{tableType}}</h3>
    <div>
      <span>Gene:</span>
      <el-select v-model="formData.Gene"
                 clearable
                 filterable
                 size="mini"
                 @change="changeGene"
                 placeholder="please select">
        <el-option
            v-for="item in gene_list_options"
            :key="item"
            :label="item"
            :value="item">
        </el-option>
      </el-select>
    </div>
    <div :id="TLSMarkerScorePicId" style="width: 380px; height: 380px"/>
  </div>
</template>

<script>
import * as echarts from "echarts/core";
import Vue from "vue";

export default {
  name: "TLSMarkerScoreCard",
  data(){
    return{
      TLSMarkerScorePicId: '',
      formData: {
        datasetID: '',
        Array: '',
        Gene: '',
      },
      SVG: {
        path: '',
        data: []
      },
      tableType: '',
      gene_list_core_region: ['SPRR2D','SPRR2E','DEFB4A','SPRR2A','LCN2','S100A7','KLK13','KLK6','IL1RN','KRT17','CEACAM6','STAT3','MUC1'],
      gene_list_leading_edge: ['COL1A1','COL1A2','COL6A2','COL3A1','VIM','COL6A1','C1QB','CTHRC1','IGFBP2','LUM','THBS4','TAGLN','C12orf75','THBS1','VCAN','DCN','FAP','ITGA5','APOE','PDPN','IGKC'],
      gene_list_options: [],
      data: [],
      position: [],
    }
  },
  props: {
    cardID: String,
  },
  mounted() {
    this.formData.datasetID = this.$attrs.data.datasetID
    this.formData.Array = this.$attrs.data.array
    this.tableType = this.$attrs.data.tableType
    this.position = this.$attrs.data.position
    console.log(this.$attrs.data)
    this.TLSMarkerScorePicId = 'marker_' + this.formData.datasetID + '_' + this.tableType + '_' + this.cardID
    console.log(this.formData.datasetID+" "+this.formData.Array)
    if (this.tableType === "core region"){
      this.gene_list_options = this.gene_list_core_region
    }else {
      this.gene_list_options = this.gene_list_leading_edge
    }
    this.$nextTick(function () {
      this.initEcharts()
    })
  },
  methods:{
    // getPosition(){
    //   let _this = this
    //   console.log(_this.formData.datasetID+" "+_this.formData.Array)
    //   _this.$axios.get(
    //       'http://' + _this.$global.serverIP + ':' + _this.$global.serverHost + '/celltype/position/' + _this.formData.datasetID + '/' + _this.formData.Array)
    //       .then(function (response) {
    //         // console.log(_this.tableType + ':')
    //         console.log(response)
    //         _this.position = eval('(' + response.data + ')')
    //         console.log(_this.position)
    //
    //       })
    // },
    initEcharts(){
      const chartDom = document.getElementById(this.TLSMarkerScorePicId);
      const myChart = echarts.init(chartDom);
      let option;
      const schema = [
        { name: 'x', index: 0, text: 'x' },
        { name: 'y', index: 1, text: 'y' },
        { name: 'gene', index: 2, text: 'gene' },
        { name: 'expression', index: 3, text: 'expression' },
      ];
      option = {
        color: ['#ff0000'],
        toolbox: {
          feature: {
            dataZoom: {
              show: true,
              title: {
                zoom: 'zoom',
                back: 'back'
              },
            },
            saveAsImage: {
              show: true,
              title: "save",
              pixelRatio: 15,  //值越大分辨率越高,下载的图片越清晰
              name: "TLS_score.png",
            },
          },
        },
        // grid: {
        //   right: '15%',
        // },
        visualMap: [
          {
            right: 0,
            bottom: '40%',
            dimension: 3,
            type: 'continuous',
            calculable:true,                        //是否显示拖拽用的手柄（手柄能拖拽调整选中范围）
            realtime:true,                          //拖拽时，是否实时更新
            precision:0,                            //数据展示的小数精度，默认为0，无小数点
            min: 0,
            max: 10,
            itemHeight: 120,
            align:"auto",
            text: ['expression'],
            textGap: 20,
            inRange: {
              color: ['#d9d9d9','blue']
            },
            outOfRange: {
              color: ['rgba(255,255,255,0.4)']
            },
            controller: {
              inRange: {
                color: ['#d9d9d9', 'blue']
              },
              outOfRange: {
                color: ['#999']
              }
            }
          }
        ],
        tooltip: {
          backgroundColor: 'rgba(255,255,255,0.7)',
          formatter: function (param) {
            // console.log(param)
            var value = param.value;
            // prettier-ignore
            return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
                + schema[2].text + '：' + value[2]
                + '</div>'
                + schema[0].text + '：' + value[0] + '<br>'
                + schema[1].text + '：' + value[1] + '<br>'
                + schema[3].text + '：' + value[3] + '<br>';
          }
        },
        xAxis: {
          type: 'value',
          name: 'x',
          nameGap: 16,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: 'y',
          nameLocation: 'end',
          nameGap: 20,
          nameTextStyle: {
            fontSize: 16
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        series: [
          {
            symbolSize: 3,
            data: [
              [1, 1,'test',20],
            ],
            type: 'scatter'
          }
        ]
      };
      option && myChart.setOption(option);
    },
    changeGene() {
      let _this = this
      console.log(_this.formData.Gene)
      _this.SVG.data = []
      if (_this.formData.Gene === ''){
        Vue.prototype.$message.warning("Please choose gene first")
        return
      }
      _this.$axios.get(
          'http://' + _this.$global.serverIP + ':' + _this.$global.serverHost + '/marker/gene/echarts/'
          + _this.formData.datasetID + '/' + _this.formData.Array + '/' + _this.formData.Gene)
          .then(function (response) {
            console.log(response.data.data)
            _this.addZeroPosition(_this.formData.Gene, response.data.data)
            if (response.status === 200) {
              Vue.prototype.$message.success(_this.formData.Gene + " success!")
              _this.reload_echarts_data()
            }
          }).catch(function () {
        Vue.prototype.$message.error(_this.formData.Gene + " Something is wrong...")
      })
    },
    reset_selected_gene() {
      let _this = this
      _this.formData.Gene = []
      _this.SVG.data = []
      _this.reload_echarts_data()
    },
    reload_echarts_data(){
      let temp_Gene = this.formData.Gene
      let _this = this
      const myChart = echarts.getInstanceByDom(document.getElementById(this.TLSMarkerScorePicId));
      let option;
      option = {
        title: {
          text: temp_Gene,
        },
        visualMap: [
          {
            min: _this.getMinV(_this.SVG.data, 3),
            max: _this.getMaxV(_this.SVG.data, 3),
          }
        ],
        dataZoom: [
          {
            left: 0,
            type: 'slider', // 放大和缩小
            orient: 'vertical',
            width: 15
          },
          {
            type: "slider",
            height: 15,
          }
        ],
        grid: {
          right: 100
        },
        series: [
          {
            symbolSize: 3,
            data: _this.SVG.data,
            type: 'scatter'
          }
        ]
      };
      myChart.setOption(option);
    },
    addZeroPosition(name, Array){
      let _this = this
      let temp = []
      for (let i =0; i< _this.position.length; i++){
        temp.push([_this.position[i].x,_this.position[i].y,name,0])
      }
      for (let i =0; i< Array.length; i++){
        temp.push(Array[i])
      }
      _this.SVG.data = temp
    },
    getMaxV(distributionInfo, dimension) {
      let max = 0
      for (let i=0;i<distributionInfo.length;i++) {
        if (max < Number(distributionInfo[i][dimension])){
          max = Number(distributionInfo[i][dimension])
        }
      }
      return max
    },
    getMinV(distributionInfo, dimension) {
      let min = 99999
      for (let i=0;i<distributionInfo.length;i++) {
        if (min > Number(distributionInfo[i][dimension])){
          min = Number(distributionInfo[i][dimension])
        }
      }
      return min
    },
  }
}
</script>

<style scoped>

</style>
